import { 
  collection, doc, onSnapshot, updateDoc, 
  query, where, orderBy, getDoc, setDoc, increment, deleteDoc
} from 'firebase/firestore';
import { firestore, FIRESTORE_COLECOES } from '../firebase';
import type { CorridaFirestore } from '../types/firestore';

/**
 * Escutar todas as corridas ativas/pendentes em tempo real para o Painel do Operador
 */
export function escutarCorridasOperador(callback: (corridas: CorridaFirestore[], error?: any) => void) {
  const colRef = collection(firestore, FIRESTORE_COLECOES.CORRIDAS);
  // Ordenar pelas mais recentes
  const q = query(colRef, orderBy('criado_em', 'desc'));
  
  return onSnapshot(q, (snapshot) => {
    const list = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    })) as CorridaFirestore[];
    callback(list);
  }, (error) => {
    console.error('Erro ao escutar corridas no Painel do Operador:', error);
    callback([], error);
  });
}

/**
 * Operador Aceita a Corrida
 */
export async function aceitarCorridaOperador(corridaId: string): Promise<void> {
  try {
    const docRef = doc(firestore, FIRESTORE_COLECOES.CORRIDAS, corridaId);
    await updateDoc(docRef, {
      status: 'aceita',
      data_aceite: new Date().toISOString()
    });
  } catch (error) {
    console.error('Erro ao aceitar corrida:', error);
    throw error;
  }
}

/**
 * Operador Recusa a Corrida com Motivo
 */
export async function recusarCorridaOperador(corridaId: string, motivo: string): Promise<void> {
  try {
    const docRef = doc(firestore, FIRESTORE_COLECOES.CORRIDAS, corridaId);
    await updateDoc(docRef, {
      status: 'recusada',
      motivo_recusa: motivo || 'Sem motoboy disponível no momento'
    });
  } catch (error) {
    console.error('Erro ao recusar corrida:', error);
    throw error;
  }
}

/**
 * Operador Envia Link de Pagamento de Cartão
 */
export async function enviarLinkPagamentoOperador(corridaId: string, linkPagamento: string): Promise<void> {
  try {
    const docRef = doc(firestore, FIRESTORE_COLECOES.CORRIDAS, corridaId);
    await updateDoc(docRef, {
      link_pagamento_cartao: linkPagamento
    });
  } catch (error) {
    console.error('Erro ao enviar link de pagamento:', error);
    throw error;
  }
}

/**
 * Operador Confirma o Pagamento da Corrida -> Transiciona para EM_ANDAMENTO
 */
export async function confirmarPagamentoOperador(corridaId: string): Promise<void> {
  try {
    const docRef = doc(firestore, FIRESTORE_COLECOES.CORRIDAS, corridaId);
    await updateDoc(docRef, {
      status: 'em_andamento',
      pagamento_confirmado: true,
      data_pagamento: new Date().toISOString()
    });
  } catch (error) {
    console.error('Erro ao confirmar pagamento:', error);
    throw error;
  }
}

/**
 * Operador Finaliza a Corrida -> Transiciona para FINALIZADO / concluida e soma aos gastos do cliente em usuarios/{clienteId}
 */
export async function finalizarCorridaOperador(
  corridaId: string, 
  clienteId: string, 
  valorTotal: number
): Promise<void> {
  try {
    const docRef = doc(firestore, FIRESTORE_COLECOES.CORRIDAS, corridaId);
    await updateDoc(docRef, {
      status: 'concluida',
      data_conclusao: new Date().toISOString()
    });

    // Somar o valor total da corrida ao total_gasto_mes e total_gasto_acumulado do cliente
    if (clienteId && valorTotal > 0) {
      const userRef = doc(firestore, FIRESTORE_COLECOES.USUARIOS, clienteId);
      const userSnap = await getDoc(userRef);
      if (userSnap.exists()) {
        await updateDoc(userRef, {
          total_gasto_mes: increment(valorTotal),
          total_gasto_acumulado: increment(valorTotal)
        });
      }
    }
  } catch (error) {
    console.error('Erro ao finalizar corrida:', error);
    throw error;
  }
}

/**
 * Operador Exclui a Corrida Definitivamente
 */
export async function excluirCorridaOperador(corridaId: string): Promise<void> {
  try {
    const docRef = doc(firestore, FIRESTORE_COLECOES.CORRIDAS, corridaId);
    await deleteDoc(docRef);
  } catch (error) {
    console.error('Erro ao excluir corrida:', error);
    throw error;
  }
}
